"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTheme = void 0;

var _colors = require("@sponte/lib-utils/dist/theme/colors");

var _icons = _interopRequireDefault(require("./icons"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var defaultColors = {
  white: '#ffffff',
  lightGrey: '#f2f4f8',
  mediumGrey: '#c6ccd7',
  darkGrey: '#919cab',
  almostBlack: '#46505a',
  black: '#000000',
  primary: '#00b7a5',
  secondary: '#7159a2',
  info: '#2689ff',
  success: '#02c836',
  warning: '#f1c04e',
  error: '#ff5758',
  red: '#DE4E51',
  pink: '#EB5387',
  purple: '#A652B4',
  deepPurple: '#8654DE',
  indigo: '#4C60D0',
  blue: '#4AAFFF',
  cyan: '#69D6E3',
  teal: '#33A59A',
  green: '#78C77C',
  lime: '#B5BF56',
  yellow: '#FFCD38',
  orange: '#F8A23D',
  deepOrange: '#FD825B',
  brown: '#C9775D'
};
var defaultBreakpoints = ['414px', '768px', '1024px', '1366px', '1920px'];
defaultBreakpoints.mobile = defaultBreakpoints[0];
defaultBreakpoints.tablet = defaultBreakpoints[1];
defaultBreakpoints.web = defaultBreakpoints[2];
defaultBreakpoints.hd = defaultBreakpoints[3];
defaultBreakpoints.fullhd = defaultBreakpoints[4];
var defaultBorderRadius = [0, 8, 20, 30, 99999999];
defaultBorderRadius.none = defaultBorderRadius[0];
defaultBorderRadius.sm = defaultBorderRadius[1];
defaultBorderRadius.md = defaultBorderRadius[2];
defaultBorderRadius.lg = defaultBorderRadius[3];
defaultBorderRadius.full = defaultBorderRadius[4];
var defaultFonts = {
  default: "'Montserrat', sans-serif"
};
var defaultFontSizes = [10, 12, 14, 16, 24, 32, 48, 64, 96, 128];
defaultFontSizes.default = defaultFontSizes[2];
defaultFontSizes.small = defaultFontSizes[0];
defaultFontSizes.medium = defaultFontSizes[1];
defaultFontSizes.large = defaultFontSizes[3];
defaultFontSizes.xlarge = defaultFontSizes[4];
var defaultFontWeights = [400, 500, 700];
defaultFontWeights.regular = defaultFontWeights[0];
defaultFontWeights.medium = defaultFontWeights[1];
defaultFontWeights.bold = defaultFontWeights[2];
var defaultSpace = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 64, 76, 128, 144, 256];
var defaultShadows = ['none', '0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)', '0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)', '0px 1px 8px 0px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 3px 3px -2px rgba(0,0,0,0.12)', '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)', '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)', '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)', '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)', '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)', '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)', '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)', '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)', '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)', '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)', '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)', '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)', '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)', '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)', '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)', '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)', '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)', '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)', '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)', '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)', '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)'];
var defaultZIndices = [];
defaultZIndices.navbar = 1100;
defaultZIndices.sidebar = 1200;
defaultZIndices.modal = 1300;
defaultZIndices.menuUserProfile = 1110;

var createTheme = function createTheme(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'default' : _ref$name,
      _ref$icons = _ref.icons,
      baseIcons = _ref$icons === void 0 ? {} : _ref$icons,
      _ref$assets = _ref.assets,
      assets = _ref$assets === void 0 ? {} : _ref$assets,
      _ref$colors = _ref.colors,
      baseColors = _ref$colors === void 0 ? {} : _ref$colors,
      _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? defaultBreakpoints : _ref$breakpoints,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? defaultBorderRadius : _ref$borderRadius,
      _ref$fonts = _ref.fonts,
      fonts = _ref$fonts === void 0 ? defaultFonts : _ref$fonts,
      _ref$fontSizes = _ref.fontSizes,
      fontSizes = _ref$fontSizes === void 0 ? defaultFontSizes : _ref$fontSizes,
      _ref$lineHeightScale = _ref.lineHeightScale,
      lineHeightScale = _ref$lineHeightScale === void 0 ? 4 : _ref$lineHeightScale,
      _ref$fontWeights = _ref.fontWeights,
      fontWeights = _ref$fontWeights === void 0 ? defaultFontWeights : _ref$fontWeights,
      _ref$space = _ref.space,
      space = _ref$space === void 0 ? defaultSpace : _ref$space,
      _ref$shadows = _ref.shadows,
      shadows = _ref$shadows === void 0 ? defaultShadows : _ref$shadows,
      _ref$zIndices = _ref.zIndices,
      zIndices = _ref$zIndices === void 0 ? defaultZIndices : _ref$zIndices,
      rest = _objectWithoutProperties(_ref, ["name", "icons", "assets", "colors", "breakpoints", "borderRadius", "fonts", "fontSizes", "lineHeightScale", "fontWeights", "space", "shadows", "zIndices"]);

  var colors = _objectSpread({}, defaultColors, {}, baseColors);

  colors.neutral = colors.neutral || colors.darkGrey;

  var icons = _objectSpread({}, _icons.default, {}, baseIcons);

  var palette = {
    primary: (0, _colors.createColorVariants)(colors.primary),
    secondary: (0, _colors.createColorVariants)(colors.secondary),
    info: (0, _colors.createColorVariants)(colors.info),
    success: (0, _colors.createColorVariants)(colors.success),
    warning: (0, _colors.createColorVariants)(colors.warning),
    error: (0, _colors.createColorVariants)(colors.error),
    neutral: {
      main: colors.darkGrey,
      dark: colors.almostBlack,
      light: colors.lightGrey
    },
    red: (0, _colors.createColorVariants)(colors.red),
    pink: (0, _colors.createColorVariants)(colors.pink),
    purple: (0, _colors.createColorVariants)(colors.purple),
    deepPurple: (0, _colors.createColorVariants)(colors.deepPurple),
    indigo: (0, _colors.createColorVariants)(colors.indigo),
    blue: (0, _colors.createColorVariants)(colors.blue),
    cyan: (0, _colors.createColorVariants)(colors.cyan),
    teal: (0, _colors.createColorVariants)(colors.teal),
    green: (0, _colors.createColorVariants)(colors.green),
    lime: (0, _colors.createColorVariants)(colors.lime),
    yellow: (0, _colors.createColorVariants)(colors.yellow),
    orange: (0, _colors.createColorVariants)(colors.orange),
    deepOrange: (0, _colors.createColorVariants)(colors.deepOrange),
    brown: (0, _colors.createColorVariants)(colors.brown),
    almostBlack: (0, _colors.createColorVariants)(colors.almostBlack)
  };
  colors = _objectSpread({}, colors, {}, Object.keys(palette).reduce(function (prev, curr) {
    var _objectSpread2;

    return _objectSpread({}, prev, (_objectSpread2 = {}, _defineProperty(_objectSpread2, "".concat(curr, "Dark"), palette[curr].dark), _defineProperty(_objectSpread2, "".concat(curr, "Light"), palette[curr].light), _objectSpread2));
  }, {}));
  var mediaQueries = Object.entries(breakpoints).reduce(function (prev, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        val = _ref3[1];

    return {
      up: _objectSpread({}, prev.up, _defineProperty({}, key, "@media screen and (min-width: ".concat(val, ")"))),
      down: _objectSpread({}, prev.down, _defineProperty({}, key, "@media screen and (max-width: ".concat(val, ")")))
    };
  }, {
    up: {},
    down: {}
  });
  return _objectSpread({
    name: name,
    icons: icons,
    assets: assets,
    colors: colors,
    palette: palette,
    fonts: fonts,
    fontSizes: fontSizes,
    lineHeightScale: lineHeightScale,
    fontWeights: fontWeights,
    space: space,
    breakpoints: breakpoints,
    radii: borderRadius,
    shadows: shadows,
    mediaQueries: mediaQueries,
    zIndices: zIndices
  }, rest);
};

exports.createTheme = createTheme;